module.exports = __webpack_public_path__ + "img/9788992711555.0f3132f2.jpg";